<template>
  <div>
    <div class="font-weight-bold font-size-15 mb-3">Основна інформація</div>
    <v-row>
      <v-col cols="12" md="6">
        <b-input
          v-model="docTypeCredentials.name"
          :error-messages="getErrorMessages(v$.name)"
          hide-details
          label="Назва"
          @blur="v$.name.$touch()"></b-input>
      </v-col>
      <v-col cols="12" md="6">
        <b-input
          v-model="docTypeCredentials.code"
          :error-messages="getErrorMessages(v$.code)"
          hide-details
          label="Код"
          @blur="v$.code.$touch()"></b-input>
      </v-col>
      <v-col cols="12" md="6">
        <b-select
          v-model="docTypeCredentials.docTypeClassId"
          :items="
            docTypeClasses.length
              ? docTypeClasses
              : [docTypeSource.docTypeClass]
          "
          :loading="$loading.isLoading('docTypeClassList')"
          hide-details
          item-title="name"
          item-value="id"
          label="Клас документа"
          @focus="getDocTypeClassList"></b-select>
      </v-col>
      <v-col cols="12" md="6">
        <b-select
          v-model="docTypeCredentials.registrationMarkType"
          :items="$directory.get('registrationMarkTypes')"
          clearable
          hide-details
          label="Реєстраційна відмітка"></b-select>
      </v-col>
      <v-col cols="12" md="6">
        <b-select
          v-model="docTypeCredentials.defaultRegistrationTypeId"
          :items="$directory.get('documentRegistrationTypes')"
          clearable
          hide-details
          label="Тип реєстрації за замовчуванням"
          @focus="$directory.fill('documentRegistrationTypes')"></b-select>
      </v-col>
      <v-col cols="12" md="6">
        <b-select
          v-model="docTypeCredentials.defaultAccessLevelTypeId"
          :items="$directory.get('accessLevelTypes')"
          clearable
          hide-details
          label="Гриф доступу за замовчуванням"
          @focus="$directory.fill('accessLevelTypes')"></b-select>
      </v-col>
      <v-col cols="12">
        <b-textarea
          v-model="docTypeCredentials.description"
          label="Опис"
          rows="2" />
      </v-col>
    </v-row>
  </div>
</template>

<script lang="ts" setup>
import { BTextarea } from 'best-modules/components/index'
import { useDocType } from '../docType'
import { getErrorMessages } from 'best-modules/utils'
import { fillDirectory } from '@/directory/index.ts'

defineOptions({
  name: 'GeneralInfo',
})

const {
  docTypeCredentials,
  v$,
  docTypeSource,
  docTypeClasses,
  getDocTypeClassList,
} = useDocType()

fillDirectory([
  'registrationMarkTypes',
  'documentRegistrationTypes',
  'accessLevelTypes',
])
</script>
